import React, { useState } from "react";
import BackBtn from "../../../Components/BackBtn/BackBtn";
import HamburgerMenu from "../../../Components/HamburgerMenu/HamburgerMenu";
import CalculatorInput from "../CalculatorInput/CalculatorInput";
import MaleOrFemale from "../MaleOrFemale/MaleOrFemale";
import CalculatorResult from "../CalculatorResult/CalculatorResult";
import Alert from "../../../Components/Alert/Alert";
import waistToHipData from "./waistToHipData";

export default function WaistToHip() {
  const [waistVal, setWaistVal] = useState(0);
  const [hipVal, setHipVal] = useState(0);
  const [showWaistTooltip, setShowWaistTooltip] = useState(false);
  const [showHipTooltip, setShowHipTooltip] = useState(false);
  const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);
  const [sex, setSex] = useState("female");
  const [result, setResult] = useState(0);
  const [showAlert, setShowAlert] = useState(false);
  const hamburgerMenuHandler = () => {
    setShowHamburgerMenu(true);
  };

  const hideMenuHandler = () => {
    setShowHamburgerMenu(false);
  };

  const handleInputChange = (val, inputName) => {
    if (inputName === "waist") {
      setWaistVal(val);
      setShowWaistTooltip(true);
    } else {
      setHipVal(val);
      setShowHipTooltip(true);
    }
  };

  const handleTouchEnd = (inputName) => {
    if (inputName === "waist") {
      setShowWaistTooltip(false);
    } else {
      setShowHipTooltip(false);
    }
  };

  const changeGender = (gender) => {
    setSex(gender);
  };

  const handleComputing = () => {
    if (hipVal !== 0) {
      let WHR = (waistVal / hipVal).toFixed(3);
      WHR = parseFloat(WHR).toString();
      //Male
      if (WHR < 0.95 && sex === "male") {
        setResult(`${WHR} کم خطر`);
      } else if (WHR > 0.95 && WHR < 1 && sex === "male") {
        setResult(`${WHR} متوسط`);
      } else if (WHR > 1 && sex === "male") {
        setResult(`${WHR} پر خطر`);
        //Female
      } else if (WHR < 0.8 && sex === "female") {
        setResult(`${WHR} کم خطر`);
      } else if (WHR > 0.81 && WHR < 0.84 && sex === "female") {
        setResult(`${WHR} متوسط`);
      } else if (WHR > 0.85 && sex === "female") {
        setResult(`${WHR} پر خطر`);
      } else {
        setResult("");
      }
    } else {
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 2000);
    }
  };
  return (
    <div className="gymBg bgContainer">
      <HamburgerMenu
        showHamburgerMenu={showHamburgerMenu}
        onHide={hideMenuHandler}
      />
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <BackBtn path="/calculator" />
            <img
              src="/images/ic_menu.svg"
              alt="menu"
              className="menuIcon"
              onClick={hamburgerMenuHandler}
            />
          </div>
          <div className="pageTitle horizontalBorder">نسبت کمر به باسن</div>
          <div className="scroll responsiveWidth calculatorPadding">
            <MaleOrFemale
              sex={sex}
              onTransGender={(gender) => changeGender(gender)}
            />
            {waistToHipData.map((data) => (
              <CalculatorInput
                key={data.id}
                {...data}
                value={data.name === "دور کمر" ? waistVal : hipVal}
                showTooltip={
                  data.name === "دور کمر" ? showWaistTooltip : showHipTooltip
                }
                onChangeVal={(val) =>
                  handleInputChange(
                    val,
                    data.name === "دور کمر" ? "waist" : "hip"
                  )
                }
                onHide={() =>
                  handleTouchEnd(data.name === "دور کمر" ? "waist" : "hip")
                }
              />
            ))}
            <CalculatorResult
              title="نسبت کمر به باسن"
              onCompute={handleComputing}
              result={result}
            />
          </div>
          <Alert
            showAlert={showAlert}
            alertText="دور باسن نباید صفر باشد"
            bottom="5rem"
          />
        </div>
      </div>
    </div>
  );
}
